export default "__VITE_ASSET__CfWW6_yO__"